/* eslint-disable @typescript-eslint/naming-convention */
export abstract class RequestRender {
    protected _nextRenderHandle: number = 0;
    // FPS 计算
    private __frameCount: number;
    private __lastTime: number;
    private __fps: number;

    private __printFPSFrom?: string;
    private __color?: string;

    constructor(printFPSFrom: string = '', color: string = '') {
        this.__printFPSFrom = printFPSFrom;
        this.__color = color;
        this.__frameCount = 0;
        this.__lastTime = performance.now();
        this.__fps = 0;
        this._nextRenderHandle = 0;
    }

    requestRenderAll() {
        if (!this._nextRenderHandle) {
            this._nextRenderHandle = requestAnimationFrame(() => this._renderAndReset());
        }
    }

    protected abstract _render(): void;

    renderAll() {
        this._cancelRequestedRender();
        this._computeFPS();
        this._render();
    }

    protected _cancelRequestedRender() {
        if (this._nextRenderHandle) {
            cancelAnimationFrame(this._nextRenderHandle);
            this._nextRenderHandle = 0;
        }
    }

    protected _renderAndReset() {
        this._nextRenderHandle = 0;
        this.renderAll();
    }

    protected _computeFPS() {
        if (!this.__printFPSFrom) return;
        this.__frameCount++;
        const currentTime = performance.now();
        if (currentTime - this.__lastTime >= 1000) {
            // 每秒更新一次
            this.__fps = this.__frameCount;
            this.__frameCount = 0;
            this.__lastTime = currentTime;
            console.log(`%c${this.__printFPSFrom} FPS: ${this.__fps}`, `color: ${this.__color || '#000'};`);
        }
    }
}
